/* Cactus: ricerca rapida che conosce il nome colore.
   La ricerca di Shopify legge titolo, tipo, varianti e SKU ma non il metafield custom.nome_card: "fiber base snow"
   trovava le FIBER BASE ma non la Snow per prima. Qui si scarica una volta l'elenco prodotti con titolo + nome
   colore (templates/collection.cfy-search-index.liquid, tenuto in memoria nel browser per qualche ora) e, a ogni
   risposta della ricerca rapida, i prodotti in cui ci sono tutte le parole cercate vanno in cima, ordinati per
   quanto combaciano (nome colore prima del titolo); sotto restano i risultati di Shopify. Se l'elenco non e'
   ancora pronto, o nessun prodotto combacia, i risultati di Shopify restano come sono. */
(function(){
  var CFG = window.CFY_SEARCH || {};
  var KEY = 'cfySearchIdx:v1:' + (CFG.url || '');
  var TTL = 6 * 3600 * 1000;
  var idx = null, loading = null;

  function norm(s){
    s = String(s || '').toLowerCase();
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch(e){}
    return s;
  }
  function esc(s){
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; });
  }
  function prep(items){
    items.forEach(function(it, i){
      it._i = i;
      it._t = ' ' + norm(it.t).replace(/[^a-z0-9]+/g, ' ') + ' ';
      it._n = ' ' + norm(it.n).replace(/[^a-z0-9]+/g, ' ') + ' ';
      it._y = ' ' + norm(it.y).replace(/[^a-z0-9]+/g, ' ') + ' ';
    });
    return items;
  }
  function fetchPage(n){
    return fetch(CFG.url + '?view=cfy-search-index&page=' + n, { credentials: 'same-origin' })
      .then(function(r){ if(!r.ok) throw new Error(r.status); return r.text(); })
      .then(function(t){ return JSON.parse(t); });
  }
  function load(){
    if(idx) return Promise.resolve(idx);
    if(loading) return loading;
    if(!CFG.url || !window.fetch) return Promise.resolve(null);
    try {
      var c = JSON.parse(localStorage.getItem(KEY) || 'null');
      if(c && c.items && Date.now() - c.t < TTL){ idx = prep(c.items); return Promise.resolve(idx); }
    } catch(e){}
    loading = fetchPage(1).then(function(first){
      var pages = Math.min(first.pages || 1, 20), more = [];
      for(var i = 2; i <= pages; i++) more.push(fetchPage(i));
      return Promise.all(more).then(function(rs){
        var items = first.items || [];
        rs.forEach(function(r){ items = items.concat(r.items || []); });
        try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), items: items })); } catch(e){}
        idx = prep(items);
        document.dispatchEvent(new CustomEvent('cfy:search-index-ready'));
        return idx;
      });
    }).catch(function(){ loading = null; return null; });
    return loading;
  }

  /* punteggio: -1 se manca una parola; ogni parola vale 3 se apre una parola del nome colore, 2 se apre una
     parola del titolo, 1 se sta altrove (dentro una parola o nel tipo); +4 se il nome colore e' tutto nella ricerca */
  function score(it, words, q){
    var s = 0;
    for(var i = 0; i < words.length; i++){
      var w = words[i], at = ' ' + w;
      if(it._n.indexOf(at) >= 0) s += 3;
      else if(it._t.indexOf(at) >= 0) s += 2;
      else if(it._n.indexOf(w) >= 0 || it._t.indexOf(w) >= 0 || it._y.indexOf(w) >= 0) s += 1;
      else return -1;
    }
    var n = it._n.trim();
    if(n && (' ' + q + ' ').indexOf(' ' + n + ' ') >= 0) s += 4;
    return s;
  }

  function handleOf(href){
    var m = /\/products\/([^?#/]+)/.exec(href || '');
    return m ? m[1] : '';
  }

  function buildItem(it){
    var h = Math.round(100 / (it.r || 1) * 100) / 100;
    var price = it.o
      ? '<div class="f-price f-price--on-sale' + (it.a ? '' : ' f-price--sold-out') + '"><div class="f-price__sale"><span class="f-price-item f-price-item--sale">' + esc(it.p) + '</span> <span class="f-price-item f-price-item--regular"><s>' + esc(it.c) + '</s></span></div></div>'
      : '<div class="f-price' + (it.a ? '' : ' f-price--sold-out') + '"><div class="f-price__regular"><span class="f-price-item f-price-item--regular">' + esc(it.p) + '</span></div></div>';
    var li = document.createElement('li');
    li.className = 'predictive-search__list-item';
    li.setAttribute('role', 'option');
    li.setAttribute('aria-selected', 'false');
    li.innerHTML =
      '<div class="flex items-center gap-3">' +
        (it.i ? '<a href="' + esc(it.u) + '" class="media-wrapper blocks-radius-sm"><img src="' + esc(it.i) + '" alt="' + esc(it.t) + '" loading="lazy" width="100" height="' + h + '"></a>' : '') +
        '<div class="grid gap-1">' +
          '<p class="block m-0"><a href="' + esc(it.u) + '" class="reversed-link text-pcard-title">' + esc(it.t) + '</a></p>' +
          (it.n ? '<p class="cfy-ps-name m-0">' + esc(it.n) + '</p>' : '') +
          '<span class="limoniapps-discountninja-productprice">' + price + '</span>' +
        '</div>' +
      '</div>';
    return li;
  }

  /* riordina l'HTML della ricerca rapida; restituisce l'HTML (invariato se non c'e' niente da fare) */
  function rerank(html, query, limit){
    if(!idx) return html;
    var q = norm(query).replace(/[^a-z0-9]+/g, ' ').trim();
    var words = q ? q.split(' ') : [];
    if(!words.length) return html;
    var hits = [];
    for(var i = 0; i < idx.length; i++){
      var s = score(idx[i], words, q);
      if(s > 0) hits.push([s, idx[i]]);
    }
    if(!hits.length) return html;
    hits.sort(function(a, b){ return b[0] - a[0] || a[1]._i - b[1]._i; });

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var box = doc.querySelector('[id^="PredictiveSearchResults-"]');
    var ul = box && box.querySelector('#predictive-search-results-products-list');
    if(!ul) return html;
    var existing = [].slice.call(ul.querySelectorAll(':scope > li'));
    var byHandle = {};
    existing.forEach(function(li){ var a = li.querySelector('a[href*="/products/"]'); var h = a && handleOf(a.getAttribute('href')); if(h && !byHandle[h]) byHandle[h] = li; });
    var max = Math.max(existing.length, parseInt(limit, 10) || 0) || existing.length;
    var out = [], used = {};
    hits.forEach(function(hit){
      if(out.length >= max) return;
      var h = handleOf(hit[1].u);
      if(!h || used[h]) return;
      used[h] = 1;
      out.push(byHandle[h] || buildItem(hit[1]));
    });
    existing.forEach(function(li){
      if(out.length >= max) return;
      var a = li.querySelector('a[href*="/products/"]'); var h = a && handleOf(a.getAttribute('href'));
      if(h && used[h]) return;
      if(h) used[h] = 1;
      out.push(li);
    });
    ul.innerHTML = '';
    out.forEach(function(li, n){ li.id = 'predictive-search-option-product-' + (n + 1); ul.appendChild(li); });
    return doc.body.innerHTML;
  }

  window.cfySearchLoad = load;
  window.cfySearchRerank = rerank;

  /* si scarica a pagina ferma, cosi' alla prima ricerca e' gia' pronto */
  function idle(){ (window.requestIdleCallback || function(f){ setTimeout(f, 2500); })(function(){ load(); }); }
  if(document.readyState === 'complete') idle(); else window.addEventListener('load', idle);
})();
